
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learn/inbody-technology",
      function () {
        return require("private-next-pages/learn/inbody-technology/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/learn/inbody-technology"])
      });
    }
  